import { SelectableModel } from '@app/component/autocomplete/abstract-autocomplete/selectable-model';
import { Contact } from '@shared/contact/contact';
import { WithContact } from '@shared/contact/with-contact';
import { OrganisationContract } from '@shared/organisation/contract/organisation-contract';
import { FieldAffiliate } from '@shared/organisation/field-affiliate/field-affiliate';
import { OrganisationUser } from '@shared/organisation/user/organisation-user';
import { User } from '@shared/user/user';

export class Organisation extends SelectableModel implements WithContact {
  contact!: Contact;
  organisationPrefix!: string;
  accountHolder!: User;

  fieldAffiliates: FieldAffiliate[] = [];
  contracts: OrganisationContract[] = [];
  users: OrganisationUser[] = [];
}
